goog.provide('yext.table.Table');
goog.provide('yext.table.Column');

require('jquery');
require('datatables.net');
require('datatables.net-jqui');
require('datatables.net-buttons');

require('datatables.net-buttons/js/buttons.html5.js');
require('datatables.net-buttons/js/buttons.print.js');

/**
 * Table is a datatable used in admin and partner portal projects
 * with various columns and a filter.
 *
 * @param   {!jQuery}  $table  The table element
 * @param   {!jQuery}  $filter The filter form
 *
 * @constructor
 */
yext.table.Table = function($table, $filter) {
  let self = this;
  this.$table = yext.table.checkExists($table);
  this.$filter = yext.table.checkExists($filter);

  this.columns = $table.find('th').map(
    (i, e) => new yext.table.Column($(e)),
  ).get();
  this.currentFilter = {};
  $filter.serializeArray().forEach(item => {
    this.currentFilter[item.name] = item.value;
  });
};

/**
 * Binds the table as a jQuery DataTable object.
 *
 * @param   {string}  ajaxSource   The path of the endpoint used in ajax search request
 * @param   {!Array}   opt_aaSorting
 * @param   {boolean=} opt_optMap   If provided, this map is merged into the the datatable options
 * The column and direction to sort on, defaults to first column and desc if not provided
 */
yext.table.Table.prototype.bind = function(ajaxSource, opt_aaSorting, opt_optMap, useNewButtonsTable) {
  var aaSorting = opt_aaSorting || [[0, 'desc']];
  var extraOpts = opt_optMap || {};

  let self = this;
  let opts = {
    'bJQueryUI': true,
    'bProcessing': true,
    'bFilter': false,
    'bServerSide': true,
    'bAutoWidth': false,
    'iDisplayLength': 25,
    'aaSorting': aaSorting,
    'sAjaxSource': ajaxSource,
    'sDom': '<"H"lT>rt<"F"ip>',
    'fnServerData': (source, data, callback) => {
      let args = self.prepareSearchRequest(data);
      $.getJSON(source, args).then(result => {
        callback({
          'iTotalRecords': result['totalRecords'],
          'iTotalDisplayRecords': result['totalMatches'],
          'aaData': self.render(result['records']),
        });
      });
    },
  };
  $.extend(opts, extraOpts);
  if (useNewButtonsTable) {
    var buttonsTable = this.$table.DataTable(opts);
    buttonsTable.buttons().container().addClass('buttons-right');
  } else {
    this.$table.dataTable(opts);
  }
};

/**
 * Creates the argument map to be passed to the server for a search.
 *
 * @param   {!Array}   data  The argument list provided by the data table plugin
 */
yext.table.Table.prototype.prepareSearchRequest = function(data) {
  let params = {
    'firstRecord': 0,
    'pageSize': 25,
  };

  data.forEach(item => {
    if (item.name === 'iDisplayStart') {
      params['firstRecord'] = item.value;
    } else if (item.name === 'iDisplayLength') {
      params['pageSize'] = item.value;
    } else if (item.name.startsWith('iSortCol_')) {
      let idx = item.name.substring('iSortCol_'.length);
      let col = this.columns[item.value];
      if (col) {
        params[`sort[${idx}].column`] = col.id;
      }
    } else if (item.name.startsWith('sSortDir_')) {
      let idx = item.name.substring('sSortDir_'.length);
      let dir = item.value === 'asc' ? 'ASCENDING' : 'DESCENDING';
      params[`sort[${idx}].direction`] = dir;
    }
  });
  $.extend(params, this.currentFilter);
  return params;
};

/**
 * Renders a result into the two-dimensional array expected by the data
 * table plugin.
 *
 * @param   {!Array}    records  The array of records from the search response
 */
yext.table.Table.prototype.render = function(records) {
  return records.map(r => this.columns.map(c => c.render(r)));
};

/**
 * Column is a column of a YAM admin table.
 *
 * @param   {!jQuery}  $header   The column header element
 *
 * @constructor
 */
yext.table.Column = function($header) {
  this.$header = $header;
  if ($header.data('column-id') != 'undefined') {
    this.id = $header.data('column-id');
  }
};

/**
 * Renders a cell value.
 *
 * @param   {!Object}  record  The record as returned from the server
 */
yext.table.Column.prototype.render = function(record) {
  return record[this.id];
};

/**
 * Verifies a jQuery Object exists and returns it, throws error if not.
 *
 * @param   {!jQuery}  $object   The object to check
 */
yext.table.checkExists = function($object) {
  if ($object.length > 0) {
    return $object;
  }
  throw new Error('Element does not exist.');
};
